import {
  CPTSlabForManualOption,
  DeliveryModes,
  TransactionType,
} from "../../../views/Orders/enums";
import { DeliveryOption, EnrichedSupplierForDelivery } from "../types";

export const TRADING_SELF_PICKUP_BLOCKED_MESSAGE =
  "Self Pickup is not available for Trading transactions. Please remove the Self Pickup delivery option(s) to continue.";

export interface SelfPickupDeliveryIndicator {
  cptSlab?: string | number | null;
  deliveryMode?: string | null;
  isDeleted?: boolean;
}

export function isTradingTransactionType(
  transactionType?: string | null,
): boolean {
  return transactionType === TransactionType.TRADING;
}

export function isSelfPickupDeliveryOption(
  delivery: SelfPickupDeliveryIndicator,
): boolean {
  const cptSlab = delivery.cptSlab;
  if (
    cptSlab === CPTSlabForManualOption.SELF_PICKUP ||
    cptSlab === String(CPTSlabForManualOption.SELF_PICKUP)
  ) {
    return true;
  }
  return delivery.deliveryMode === DeliveryModes.SELF_PICKUP;
}

export function splitHasSelfPickupDeliveryOptions(
  supplier: EnrichedSupplierForDelivery,
): boolean {
  const activeOptions = (supplier.deliveryOptions ?? []).filter(
    (option) => !(option as { isDeleted?: boolean }).isDeleted,
  );
  return activeOptions.some((option) => isSelfPickupDeliveryOption(option));
}

export function isSupplierSplitValidForTradingSelfPickup(
  supplier: EnrichedSupplierForDelivery,
): boolean {
  if (supplier.supplierId == null) {
    return true;
  }
  if (!isTradingTransactionType(supplier.transactionType)) {
    return true;
  }
  return !splitHasSelfPickupDeliveryOptions(supplier);
}

export function hasTradingSplitWithSelfPickupOptions(
  suppliers: EnrichedSupplierForDelivery[],
): boolean {
  return suppliers.some(
    (supplier) => !isSupplierSplitValidForTradingSelfPickup(supplier),
  );
}

export function isTradingWithSelfPickupManualEntry(
  transactionType: string | undefined | null,
  cptSlab: CPTSlabForManualOption | undefined,
): boolean {
  return (
    isTradingTransactionType(transactionType) &&
    cptSlab === CPTSlabForManualOption.SELF_PICKUP
  );
}

export function getActiveDeliveryOptions(
  deliveryOptions: DeliveryOption[] | undefined,
): DeliveryOption[] {
  return (deliveryOptions ?? []).filter(
    (option) => !(option as { isDeleted?: boolean }).isDeleted,
  );
}
